var _defs, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHtml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "html",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 526 396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cdeeff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.84,13.13c.06.59.18,1.18.18,1.76q0,23,0,46c0,.65-.07,1.31-.12,2.09H305.48V39.3l-.56-.17-11.09,17.1L282.3,38.47V62.88H266.07c-.05-.57-.14-1.07-.14-1.58V14c0-.3.07-.59.1-.89h17.41c3.45,5.78,6.89,11.56,10.55,17.68l10.44-17.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.3,13.13v49.8H188.65V50.43a15.44,15.44,0,0,0-.06-2.89c-.09-.47-.72-1.18-1.12-1.19-4.59-.08-9.19-.05-14.1-.05V63H156.63V13.13h16.52V29.47h15.63V13.13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.44,13.13V29.58H243.89V63H227.3V29.72H212.45V13.13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.85,13.13q.07,12.37.14,24.74c0,2.8,0,5.61,0,8.68h23.39V62.91H330.32V13.13Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.7,85.63l24,268,107.24,29.95L370.7,353.63l23.48-268Zm211,88h-126l3,33H339.51l-8.81,101-67.76,19.23L195.7,308.63l-5-52h34l2,26,36.24,9.71,36.76-9.71,4-43h-114l-9-99H345.18Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHtml);
export default __webpack_public_path__ + "static/media/icon-html.81ab74bba2df68c864f1c9070a11e2a0.svg";
export { ForwardRef as ReactComponent };